

































































































import {
  apiCommodityCommonCommodityAddressList,
  apiOrderOrderDetail,
  apiOrderOrderModifyAddress,
} from '@/api'
import { computed, ref } from '@vue/composition-api'
import { defineClassComponent, useApiPlus, useQuery } from '@/hooks'
import { navigateBack, navigateTo } from '@/router'
import { submit, Track } from '@/utils'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '修改地址',
        }))
      }

      loading = computed(() => this.apiData.loading)

      query = useQuery<{
        orderNo: string
      }>()

      apiData = useApiPlus(
        {
          orderData: () =>
            apiOrderOrderDetail({
              orderNo: this.query.orderNo,
            }).then(async res => ({
              ...res,
              addressData: await apiCommodityCommonCommodityAddressList({
                commodityIds: res.commodities!.map(item => item.commodityId!),
                districtCode: '',
              }).then(res => res.list),
            })),
        },
        {
          refreshOnActivated: true,
        },
      )

      orderData = computed(() => this.apiData.data.orderData)

      receiverData = computed(() => this.orderData.value.consigneeInfo)

      addressData = computed(() => this.apiData.data.orderData.addressData!)

      availableAddressData = computed(() =>
        this.addressData.value.filter(item => !!item.serviceFlag),
      )

      unavailableAddressData = computed(() =>
        this.addressData.value.filter(item => !item.serviceFlag),
      )

      addressIndex = ref(-1)

      handleCancelClick = () => {
        navigateBack()
      }

      handleAddClick = () => {
        navigateTo('AddressEdit')
      }

      handleConfirmClick = () => {
        submit(async $ => {
          if (this.addressIndex.value === -1) {
            return $.fail('请选择新的收货地址')
          }
          const address =
            this.availableAddressData.value[this.addressIndex.value]
          $.start('提交中...')
          await apiOrderOrderModifyAddress({
            orderNo: this.query.orderNo,
            consigneeAddress: {
              province: address.province,
              provinceCode: address.provinceCode,
              city: address.city,
              cityCode: address.cityCode,
              area: address.county,
              areaCode: address.districtCode,
              detail: address.detail,
              name: address.receiver,
              phoneNo: address.phoneNo,
            },
          })
          await $.success('提交成功')
          navigateBack()
        })
      }
    },
)
